// components/ModalPortal.jsx
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";

export default function ModalPortal({ children }) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    const el = document.createElement("div");
    el.id = "modal-root";
    document.body.appendChild(el);
    setContainer(el);
    return () => el.remove();  // cleanup on unmount
  }, []);

  return container ? createPortal(children, container) : null;
}
